import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppConfigService } from '@data-terminal/data-access/app-config/app-config.service';
import { OrganizationService } from '@data-terminal/data-access/organization';
import { HdmuiAppConfigProvider } from '@heidelberg/hdmui-angular';
import { TranslateService } from '@ngx-translate/core';
import { IS_PRODUCTION } from '@data-terminal/data-access/injection-tokens';
import { map } from 'rxjs';

export function provideAppConfigProvider(): HdmuiAppConfigProvider {
    const appConfigService = inject(AppConfigService);
    const organizationService = inject(OrganizationService);
    const translateService = inject(TranslateService);
    const isProduction = inject(IS_PRODUCTION);
    const COULD_NOT_FETCH_VERSION = 'Could not fetch Version';
    return {
        appId: 'data-terminal',
        appTitle: 'DC.APP.TITLE',
        appCategory: '*.appCategory.production',
        appStage: isProduction ? undefined : appConfigService.getStage(),
        ccStage: isProduction ? undefined : ('stage' as const),
        thirdPartyLicencePath: './assets/generated/3rdpartylicences.txt',
        appVersions: toSignal(
            organizationService.appVersions$.pipe(
                map((appVersionsInfo) => [
                    {
                        text: translateService.instant('*.versionUi'),
                        value: appVersionsInfo.feVersion,
                    },
                    {
                        text: translateService.instant('*.versionService'),
                        value: appVersionsInfo.backendVersion ?? COULD_NOT_FETCH_VERSION,
                    },
                    {
                        text: translateService.instant('*.versionInstaller'),
                        value: appVersionsInfo.onPremVersion ?? COULD_NOT_FETCH_VERSION,
                    },
                ])
            ),
            { initialValue: [] }
        ),
    };
}
